export default {
      id: "arrow-thick-right-usage",
      viewBox: "0 0 53 54",
      url: "../../assets/" + "sprite.svg#arrow-thick-right-usage",
      toString: function () {
        return this.url;
      }
    }